import React from 'react';
import VideCard from './VideCard.jsx';
import '../styles/Videos.css';
const Videos = ({ videos }) => {
  return (
    <div className="videos">
      {videos.map((item, index) => (
        <VideCard
          index={index}
          key={item.index}
          image={item.image}
          name={item.name}
        />
      ))}
    </div>
  );
};

export default Videos;
